import styled from "styled-components";

export const MainContainer = styled.section`
  background: rgba(0, 0, 0, 0.5);
  height: 100%;
  width: 100%;
  display: ${props => props.display !== "" ? props.display : "none"};
  position: fixed;
  z-index: 50;
  top: 0px;
  left: 0px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const OtpContainer = styled.section`
    display: flex;
    border-radius: 16px;
    width:630px;
    background-color: #FFF;
    padding: 16px;
    flex-direction: column;

    @media (max-width: 426px) {
        height: ${props => (props.width === "70%" ? "100%" : "")};
        width: ${props => (props.width === "70%" ? "100%" : "")};
        border-radius: ${props => (props.borderRadius !== "" ? "0" : "")};

        ${props => (props.isSuccess)} & {
            width: 100%;
            gap: 10px;
            border-top-left-radius: 24px;
            border-top-right-radius: 24px;
            position: absolute;
            bottom: 0;
        }
    }
`;

export const DigitsContainer = styled.div`
  display: flex;
  width: 328px;
  padding-top: 8px;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  border-radius: 4px;
  justify-content: center;
`;

export const SingleDigitInput = styled.input`
  display: flex;
  width: 50px;
  height: 50px;
  flex-direction: column;
  justify-content: center;
  box-shadow: none;
  align-items: center;
  gap: 10px;
  border-radius: var(--8px, 8px);
  border: 0.6px solid var(--Greyscale-GREY-300, #A8ACB8);
  background: var(--Greyscale-GREY-025, #F5F6F7);
`

export const BlueUnderlinedBoldLink = styled.button`
  display: flex;
  gap: 4px;
  flex-direction: row;
  align-items: center;
  font-family: 'RobotoMedium';
  color: var(--Accent-BLUE-200, #007C92);
  text-align: right;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 150% */
  text-decoration-line: none;
  cursor: pointer;
  background: none;
  border: none;

  &:focus, &:hover, &:focus-visible {
    border: none;
    text-decoration-line: underline;
    outline: none;
  }
`;

export const OTPInputContainer = styled.section`
  justify-content: center;
  align-items: center;
`;

export const TextInputHidden = styled.input`
  width: 300px;
  border-color: #e5e5e5;
  border-width: 1px;
  border-radius: 5px;
  padding: 15px;
  display: none;
`;

export const SplitOTPBoxesContainer = styled.div`
  display: flex;
  width: 328px;
  padding-top: 8px;
  flex-direction: row;
  -webkit-box-align: center;
  align-items: center;
  gap: 16px;
  border-radius: 4px;
  -webkit-box-pack: center;
  justify-content: center;
`;

export const SplitBoxText = styled.input`
  text-align: center;
  display: flex;
  width: 50px;
  height: 50px;
  flex-direction: column;
  justify-content: center;
  box-shadow: none;
  align-items: center;
  gap: 10px;
  border-radius: var(--8px, 8px);
  border: 0.6px solid var(--Greyscale-GREY-300, #A8ACB8);
  background: var(--Greyscale-GREY-025, #F5F6F7);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;

  &:focus {
    outline: none;
  }
`;